import { BrowserRouter } from "react-router-dom";
import { NavigationTracker } from "@circle-react/components/AnalyticsTracker/NavigationTracker";
import { HelpWidgetContextProvider } from "@circle-react/components/HelpWidget/context/HelpWidgetContext";
import { SupportWidgetContextProvider } from "@circle-react/components/SupportWidget/SupportWidgetContext";
import { LayoutPartialsContextProvider } from "@circle-react/contexts/layoutPartialsContext";
import { SpaceGroupsContextProvider } from "@circle-react/contexts/spaceGroupsContext";
import { SpacesContextProvider } from "@circle-react/contexts/spacesContext";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import type { AppContextProviderProps } from "../AppContext";
import { AppContextProvider } from "../AppContext";
import { QueryClientProvider } from "../QueryClient";
import { ThemeProvider } from "../Theme";
import { RouteChangeEventWrapper } from "./RouteChangeEventWrapper";

export interface MainAppProviders {
  backendProps?: AppContextProviderProps["backendProps"];
  children: React.ReactNode;
}

// "backendProps" comes from app/views/shared/_react_app.html.erb
export const MainAppProviders = ({
  children,
  backendProps = {},
}: MainAppProviders) => {
  const {
    community_theme_settings = {},
    brand_color = {
      light: "",
      dark: "",
    },
    brand_text_color = {
      light: "",
      dark: "",
    },
  } = backendProps;

  const theme = {
    ...community_theme_settings,
    brand_color,
    brand_text_color,
  };

  return (
    <QueryClientProvider>
      <ThemeProvider theme={theme}>
        <AppContextProvider backendProps={backendProps}>
          <LayoutPartialsContextProvider>
            <SpaceGroupsContextProvider>
              <SpacesContextProvider includeSidebar>
                <ToastProvider>
                  <HelpWidgetContextProvider>
                    <SupportWidgetContextProvider>
                      <BrowserRouter>
                        <RouteChangeEventWrapper>
                          <NavigationTracker>{children}</NavigationTracker>
                        </RouteChangeEventWrapper>
                      </BrowserRouter>
                    </SupportWidgetContextProvider>
                  </HelpWidgetContextProvider>
                </ToastProvider>
              </SpacesContextProvider>
            </SpaceGroupsContextProvider>
          </LayoutPartialsContextProvider>
        </AppContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
